import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { db } from '../../services/db';
import Button from '../common/Button';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Resources = () => {
  const { t } = useLanguage();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);
  const [email, setEmail] = useState('');

  const resources = t('resources.items');
  const icons = [FiIcons.FiBook, FiIcons.FiTrendingUp, FiIcons.FiCheckSquare, FiIcons.FiEdit3];

  const handleDownload = (resource) => {
    setSelectedResource(resource);
    setModalOpen(true);
  };

  const submitDownload = async (e) => {
    e.preventDefault();
    await db.saveLead(email, `Resource: ${selectedResource.title}`);
    setModalOpen(false);
    alert(`Downloading ${selectedResource.title}...`);
    // In real app, trigger actual download here
  };

  return (
    <section id="resources" className="py-20 bg-pink-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">{t('resources.title')}</h2>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {resources.map((res, idx) => (
            <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-12 h-12 bg-pink-100 text-pink-600 rounded-lg flex items-center justify-center mb-4">
                <SafeIcon icon={icons[idx]} className="text-2xl" />
              </div>
              <h3 className="font-bold text-lg mb-2 min-h-[50px]">{res.title}</h3>
              <p className="text-gray-500 text-sm mb-6">{res.desc}</p>
              <button 
                onClick={() => handleDownload(res)}
                className="text-pink-600 font-bold text-sm flex items-center gap-1 hover:gap-2 transition-all"
              >
                {t('resources.download')} <SafeIcon icon={FiIcons.FiArrowRight} />
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full relative">
            <button onClick={() => setModalOpen(false)} className="absolute top-4 right-4 text-gray-400 hover:text-black">
              <SafeIcon icon={FiIcons.FiX} className="text-2xl" />
            </button>
            <h3 className="text-2xl font-bold mb-4">Send me the guide!</h3>
            <p className="text-gray-600 mb-6">Enter your email to receive <strong>{selectedResource?.title}</strong> instantly.</p>
            <form onSubmit={submitDownload} className="flex flex-col gap-4">
              <input 
                type="email" 
                required 
                placeholder="Email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full px-4 py-3 border rounded-lg"
              />
              <Button type="submit" className="w-full">Send Now</Button>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default Resources;